import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/faturamento';

export default {
  buscarCards: async (competencia) => financeiroApi.get(`${PATH}/kanban`, { params: { competencia } }),
  pendencias: async (payload) => financeiroApi.post(`${PATH}/pendencias`, payload),
  verificarPendencias: async (competencia) =>
    financeiroApi.get(`${PATH}/verificar-pendencia`, { params: { competencia } }),
  buscarFaturamentoVenda: async (faturamentoId) =>
    financeiroApi.get(`${PATH}/buscarFaturamentoVenda`, { params: { faturamentoId } }),
  buscarPelaVendaId: async (vendaId) =>
    financeiroApi.get(`${PATH}/buscarFaturamentoPelaVendaId`, { params: { vendaId } }),
  movimentar: async (faturamentoId, sourceLane, targetLane, competencia) =>
    financeiroApi.get(`${PATH}/movimentar`, { params: { faturamentoId, sourceLane, targetLane, competencia } }),
  buscarFaturamentoContrato: async (faturamentoId) =>
    financeiroApi.get(`${PATH}/buscarFaturamentoContrato`, { params: { faturamentoId } }),
  faturarTodos: async (payload, competencia) =>
    financeiroApi.post(`${PATH}/faturarTodos?competencia=${competencia}`, payload),
  faturar: async (payload, tipoFaturamento, competencia) =>
    financeiroApi.post(`${PATH}/faturar?tipoFaturamento=${tipoFaturamento}&competencia=${competencia}`, payload),
  excluir: async (faturamentoId, competencia) =>
    financeiroApi.delete(`${PATH}`, { params: { faturamentoId, competencia } }),
  enviarNfEmail: async (faturamentoId) => financeiroApi.get(`${PATH}/enviar-nf-email/${faturamentoId}`),
  cancelarNF: async (faturamentoId, competencia) =>
    financeiroApi.post(`${PATH}/cancelar-nota?faturamentoId=${faturamentoId}&competencia=${competencia}`),
  cancelarNFeCriarNovoFaturamento: async (faturamentoId, competencia) =>
    financeiroApi.post(`${PATH}/cancelar-nota?faturamentoId=${faturamentoId}&competencia=${competencia}&novo=${true}`),

  atualizarNotaHomol: async (situacao) => financeiroApi.get(`${PATH}/atualizar-nota-homol/${situacao}`),

  verificarLimitePlanoNfse: async () => financeiroApi.get(`${PATH}/notificar/limite-plano/nfse`),

  verificarLimitePlanoNfe: async () => financeiroApi.get(`${PATH}/notificar/limite-plano/nfe`),

  cadastrarNotaDevolucao: async (notaDevolucao) => {
    return financeiroApi.post(`${PATH}/devolucao`, notaDevolucao);
  },
  validarPendenciasNotaDevolucao: async (notaDevolucao) => {
    return financeiroApi.post(`${PATH}/devolucao/pendencias`, notaDevolucao);
  },
  buscarNotaDevolucao: async (id) => financeiroApi.get(`${PATH}/devolucao/${id}`),
  reenviarNotaParaEmissao: async (uuid) => financeiroApi.post(`${PATH}/devolucao/reenviar=${uuid}`),
  faturamentoAutomaticoVenda: async () => financeiroApi.get(`${PATH}/automatico/VENDA`),

  faturamentoAutomaticoContrato: async () => financeiroApi.get(`${PATH}/automatico/CONTRATO`),

  desvincularFaturamentoContratoVenda: async (faturamentosIds) => {
    return financeiroApi.put(`${PATH}/desvincular-contrato-venda`, faturamentosIds);
  },
};
